var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.508 97.502a2.795 2.795 0 0 1 2.795-4.84c16.934 9.776 38.587 3.974 48.363-12.96 9.777-16.934 3.975-38.587-12.959-48.363-16.933-9.777-38.586-3.975-48.363 12.959a35.338 35.338 0 0 0-4.18 11.351 2.795 2.795 0 1 1-5.5-1.002 40.928 40.928 0 0 1 4.839-13.145c11.32-19.607 36.392-26.325 56-15.005 19.607 11.32 26.325 36.393 15.005 56-11.32 19.608-36.393 26.326-56 15.005z",
    fill: "#FF9B01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103a2.796 2.796 0 0 1 0-5.59c19.556 0 35.41-15.854 35.41-35.41 0-19.556-15.854-35.41-35.41-35.41-19.556 0-35.41 15.854-35.41 35.41 0 4.115.702 8.131 2.057 11.922a2.796 2.796 0 0 1-5.264 1.882A40.934 40.934 0 0 1 21 62c0-22.644 18.356-41 41-41s41 18.356 41 41-18.356 41-41 41z",
    fill: "#99A2AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderImage);
export default __webpack_public_path__ + "static/media/loader-image.9c96fd8e064d47a0e7b52317e042c098.svg";
export { ForwardRef as ReactComponent };